export const MODULE_NAME = 'codeless-events';

export const CODELESS_EVENTS_ROUTE = `/${MODULE_NAME}`;
